import cx from "classnames";
import { memo, useMemo } from "react";
import QRCode from "react-qr-code";
import { IonLabel, IonSkeletonText } from "@ionic/react";

import { useEasyOnboardingDownloadLink } from "../hooks/useEasyOnboardingDownloadLink";
import s from "./EasyOnboardingQr.module.scss";

type EasyOnboardingQrProps = {
  staticQrSrc: string;
  qrClassName?: string;
  scanTextClassName?: string;
  scanLabel?: string;
};

const EasyOnboardingQr = ({
  staticQrSrc,
  qrClassName,
  scanTextClassName,
  scanLabel = "Scan here to download",
}: EasyOnboardingQrProps) => {
  const { branchUrl, useBranchLink, isEasyOnboardingEnabled, isLoading } =
    useEasyOnboardingDownloadLink();

  const scanLabelElement = useMemo(() => {
    if (!scanTextClassName) {
      return null;
    }

    return (
      <IonLabel className={scanTextClassName}>
        {isEasyOnboardingEnabled && isLoading
          ? "Preparing download link…"
          : scanLabel}
      </IonLabel>
    );
  }, [
    isEasyOnboardingEnabled,
    isLoading,
    scanLabel,
    scanTextClassName,
  ]);

  if (!isEasyOnboardingEnabled) {
    return (
      <>
        <img className={qrClassName} src={staticQrSrc} alt="" loading="lazy" decoding="async" />
        {scanLabelElement}
      </>
    );
  }

  if (isLoading) {
    return (
      <>
        <div className={cx(s.qrPlaceholder, qrClassName)} aria-hidden="true">
          <IonSkeletonText animated className={s.qrSkeleton} />
        </div>
        {scanLabelElement}
      </>
    );
  }

  if (useBranchLink && branchUrl) {
    return (
      <>
        <div className={cx(s.qrCode, qrClassName)}>
          <QRCode value={branchUrl} size={512} className={s.qrSvg} />
        </div>
        {scanLabelElement}
      </>
    );
  }

  return (
    <>
      <img className={qrClassName} src={staticQrSrc} alt="" loading="lazy" decoding="async" />
      {scanLabelElement}
    </>
  );
};

export default memo(EasyOnboardingQr);
